import * as React from 'react';

import Component from './Pressable';
import { PressableProps } from './model';

export type { PressableProps };

/**
 * Pressable component that can give pressable actions and effects to other components.
 */
export const Pressable: React.FC<PressableProps> = (props) => {
	return <Component {...props} />;
};
